import { DEFAULT_TIMEZONE } from '../../constants/workTime';
import { IApplicationState } from '../../types/redux';

export const selectTimezone = (state: IApplicationState): number => {
  return state.developer.timezone ?? DEFAULT_TIMEZONE;
};
